import { render, staticRenderFns } from "./approvalManagement.vue?vue&type=template&id=b348327a&scoped=true"
import script from "./approvalManagement.vue?vue&type=script&lang=js"
export * from "./approvalManagement.vue?vue&type=script&lang=js"
import style0 from "./approvalManagement.vue?vue&type=style&index=0&id=b348327a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b348327a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b348327a')) {
      api.createRecord('b348327a', component.options)
    } else {
      api.reload('b348327a', component.options)
    }
    module.hot.accept("./approvalManagement.vue?vue&type=template&id=b348327a&scoped=true", function () {
      api.rerender('b348327a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/approvalManagement/approvalManagement.vue"
export default component.exports